import {createContext} from 'react';
const SystemConfigrationContext= createContext([])
export default SystemConfigrationContext;